import { Suspense, useMemo } from 'react';
import cn from 'classnames';

import Divider from '@mui/material/Divider';

import { EMeetingType, IVideoStream } from '@src/types';
import { usePagination } from '@src/hooks';
import useVideosContainer from '@src/components/VideosContainer/useVideosContainer';
import PipAvatar from './PipAvatar/pipAvatar';

import styles from './MobilePip.module.scss';
import { OLoader } from '@src/shared';
import AudioContainer from '../AudioContainer';
import { useRoomStore, useWebinarRoomStore } from '@src/stores';
import { useShallow } from 'zustand/react/shallow';
import VideosContainer from '../VideosContainer';

const MobilePipContent = () => {
  const { videosContainerRef, paginatedVideoList, currentUser, sortedVideos, videoStreams } = useVideosContainer();

  const { attendeeDetails } = useWebinarRoomStore(
    useShallow((state) => ({
      attendeeDetails: state.attendeeDetails,
    }))
  );

  const { currentPage } = usePagination<IVideoStream>({
    perPage: 2,
    data: paginatedVideoList,
    ref: videosContainerRef,
    childSelector: '.video-screen-container',
  });

  const { meetingType } = useRoomStore(
    useShallow((state) => ({
      meetingType: state.meetingType,
    }))
  );

  const videosExcludingCurrentUser = useMemo(() => {
    return sortedVideos.filter((x: any) => !x.isCurrentUser);
  }, [sortedVideos]);

  return (
    <div className="h-full">
      <div className={cn(styles.mobilePipContainer)} ref={videosContainerRef}>
        {meetingType === EMeetingType.WEBINAR && attendeeDetails?.user?.type === undefined ? (
          <VideosContainer />
        ) : (
          <>
            {currentUser && <PipAvatar {...currentUser} key={`${currentUser.id}`} />}
            <Divider orientation="vertical" flexItem sx={{ bgcolor: 'var(--pip-divider-bg)', width: '2px' }} />
            {videosExcludingCurrentUser[0] && currentPage.length <= 2 ? (
              <PipAvatar {...videosExcludingCurrentUser[0]} key={`${videosExcludingCurrentUser[0].id}`} />
            ) : (
              <div className={cn(styles.videoContainer)}>
                <p> You're alone on the call</p>
              </div>
            )}
          </>
        )}
        {meetingType !== EMeetingType.WEBINAR && (
          <Suspense fallback={<OLoader />}>
            <AudioContainer />
          </Suspense>
        )}
        {videoStreams.length > 2 && (
          <div className={cn(styles.participantCounter, 'absolute right-2 bottom-1 flex items-center gap-2')}>
            <span className="text-xs">+{videoStreams.length - 2}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobilePipContent;
